import { computed, readonly, ref } from 'vue'

/**
 * Kontekst produktu, z którego otwarto zapytanie o wycenę.
 *
 * `name` służy WYŁĄCZNIE do pokazania użytkownikowi, czego dotyczy zapytanie —
 * do backendu jedzie sam identyfikator, a nazwę i SKU czyta on z bazy w chwili
 * zapytania. Dzięki temu nie da się podstawić dowolnej nazwy do wątku w panelu.
 */
export interface QuoteRequestContext {
  /** Liczba albo cyfrowy ciąg — `Product.id` z API jest typu string. */
  idProduct: number | string | null
  /**
   * Wybrany wariant (kombinacja). Jedzie do backendu jako id_product_attribute —
   * opis wariantu i jego SKU backend czyta z bazy. Brak/0 = bez wariantu.
   */
  idProductAttribute?: number | string | null
  name?: string
  reference?: string
  /** Opis wariantu do pokazania w formularzu, np. „Rozmiar: XXL". */
  attributes?: string
  /**
   * Lista Zapytania — gdy obecna, zapytanie dotyczy wielu produktów naraz,
   * a nakład jest przy każdej pozycji (pole „Nakład" w formularzu znika).
   * Do backendu jadą same identyfikatory i liczby sztuk.
   */
  items?: Array<{ id_product: number, quantity: number, id_product_attribute?: number }>
}

const _context = ref<QuoteRequestContext | null>(null)

/**
 * Sterowanie modalem zapytania ofertowego. Wzorzec z useQuickView: stan w
 * module, jeden modal zamontowany w layoucie, otwierany z dowolnego miejsca
 * (karta produktu, listing, szybki podgląd, pasek przyklejony).
 */
export function useQuoteRequest() {
  function open(context: QuoteRequestContext | null = null) {
    _context.value = context ?? { idProduct: null }
  }

  function close() {
    _context.value = null
  }

  return {
    context: readonly(_context),
    isOpen: computed(() => _context.value !== null),
    open,
    close,
  }
}
